import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={87}
    height={32}
    fill="none"
    {...props}
  >
    <foreignObject width={94} height={40} x={-3.386} y={-4}>
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(2px)",
          clipPath: "url(#a)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <rect
      width={85}
      height={31}
      x={1.114}
      y={0.5}
      fill="url(#b)"
      stroke="url(#c)"
      data-figma-bg-blur-radius={4}
      rx={15.5}
    />
    <path
      fill="#fff"
      d="M23.166 14.154h.98v6.692c0 .658-.182.952-.714 1.092-.518.154-1.428.168-2.87.154-.042-.266-.224-.672-.378-.938 1.204.042 2.268.028 2.59.014.294-.014.392-.084.392-.336v-6.678Zm-5.194-3.766h10.164v.924H17.972v-.924Zm9.898 0h.238l.224-.056.728.532c-1.33 1.456-3.444 3.024-5.264 3.934a5.487 5.487 0 0 0-.63-.644c1.708-.854 3.738-2.394 4.704-3.528v-.238Zm4.662 2.422h4.088v.756h-4.088v-.756Zm0 2.394h4.088v.728h-4.088v-.728Zm0 2.45h4.088v.756h-4.088v-.756Zm5.95-1.764h5.334v.826h-5.334v-.826Zm-5.208-5.376h2.338v.756h-2.338v-.756Zm4.34-.532h5.53v.798h-5.53v-.798Zm-.196 8.526h6.65v.84h-6.65v-.84Zm3.01-4.088h.896v7.616h-.896V14.42Zm-6.118-1.246h.7v4.816h-.7v-4.816Zm8.512-3.192h.854s0 .238-.014.364c-.112 2.352-.238 3.248-.532 3.57-.182.224-.392.308-.756.322-.28.028-.868.028-1.456 0-.028-.252-.112-.588-.224-.798.574.056 1.12.056 1.316.056.196.014.322-.014.406-.112.182-.224.308-1.05.406-3.276v-.126Zm-4.214 4.578.826.154c-.294 1.302-.798 2.576-1.386 3.416a5.476 5.476 0 0 0-.756-.392c.616-.812 1.064-1.988 1.316-3.178Zm-5.306-5.306.868.196c-.518 1.89-1.372 3.682-2.366 4.858a5.231 5.231 0 0 0-.728-.56c1.008-1.078 1.792-2.758 2.226-4.494Zm-1.134 3.556h.784v3.738c0 1.694-.168 4.032-1.148 5.572a4.285 4.285 0 0 0-.686-.42c.952-1.498 1.05-3.584 1.05-5.166V12.81Zm4.186 0h.812v8.218c0 .49-.126.77-.462.91-.35.14-.91.14-1.918.14-.028-.21-.168-.574-.294-.798.756.014 1.4.014 1.596.014.196-.014.266-.07.266-.266V12.81Zm3.304-2.576h.882c-.266 1.918-.896 3.528-2.828 4.396-.112-.196-.336-.49-.532-.644 1.736-.742 2.268-2.156 2.478-3.752Zm-4.27.28h.182l.14-.042.56.35a13.49 13.49 0 0 1-1.246 2.548 2.744 2.744 0 0 0-.616-.364c.364-.616.77-1.638.98-2.338v-.154Zm10.136-.476H57.69v.854H45.524v-.854Zm5.684.364h.966v5.39c0 2.674-.658 5.096-6.328 6.314a6.082 6.082 0 0 0-.56-.812c5.53-1.064 5.922-3.178 5.922-5.516v-5.376Zm-3.5 4.788v1.512h8.162V15.19h-8.162Zm0-2.254v1.484h8.162v-1.484h-8.162Zm-.896-.798h10.01V17.5h-10.01v-5.362Zm1.288 5.516c1.75 2.8 4.928 3.346 10.038 3.5-.168.21-.35.616-.406.924-5.18-.238-8.596-.924-10.416-4.102l.784-.322Zm14.056-5.362.63-.56c1.078.504 2.394 1.316 3.052 1.918l-.672.616c-.63-.602-1.932-1.442-3.01-1.974Zm6.496-1.82h.196l.168-.042.602.378c-1.82 3.234-5.992 5.236-9.618 6.034-.098-.238-.28-.63-.448-.826 3.472-.672 7.546-2.604 9.1-5.39v-.154Zm-4.732 0h4.97v.812h-4.97v-.812Zm1.092-1.218 1.064.224c-1.274 1.456-3.178 2.87-5.782 3.906-.14-.238-.434-.546-.644-.714 2.534-.882 4.396-2.226 5.362-3.416Zm-1.092 8.134.7-.532c1.148.588 2.534 1.512 3.22 2.198l-.742.616c-.644-.7-2.016-1.652-3.178-2.282Zm6.818-2.058h.196l.182-.042.602.35c-1.778 4.06-6.202 5.838-10.724 6.496a3.232 3.232 0 0 0-.42-.854c4.326-.532 8.624-2.24 10.164-5.796v-.154Zm-4.62 0h4.872v.812h-4.872v-.812Zm1.162-1.302 1.05.238c-1.4 1.624-3.612 3.15-6.678 4.228a4.064 4.064 0 0 0-.588-.728c2.968-.924 5.124-2.394 6.216-3.738Z"
    />
    <defs>
      <linearGradient
        id="b"
        x1={43.614}
        x2={43.614}
        y1={0}
        y2={32}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C866B" />
        <stop offset={0.14} stopColor="#8F896D" stopOpacity={0.96} />
        <stop offset={0.32} stopColor="#999274" stopOpacity={0.84} />
        <stop offset={0.53} stopColor="#A9A07F" stopOpacity={0.8} />
        <stop offset={1} stopColor="#999274" stopOpacity={0.4} />
      </linearGradient>
      <linearGradient
        id="c"
        x1={4.149}
        x2={71.148}
        y1={13.59}
        y2={47.514}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.08} stopColor="#8C866B" />
        <stop offset={0.26} stopColor="#8C866A" />
        <stop offset={0.45} stopColor="#F5E6B6" />
        <stop offset={0.59} stopColor="#7D7649" />
        <stop offset={0.84} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
      <clipPath id="a" transform="translate(3.386 4)">
        <rect width={85} height={31} x={1.114} y={0.5} rx={15.5} />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
